import {
  TrendDirectionName,
  TrendFilter_Input,
  TrendName
} from 'generated/graphql';
import { appFormUtil } from 'modules/common';
import React from 'react';
import {
  IFilterListedCompanyFormUtil,
  IFormState
} from './types';

const initialFormState: IFormState = {
  rows: [{
    id: '123',
    name: '',
    direction: ''
  }]
};
export function useQuery() {

  const form = appFormUtil.useFormState({
    initialState: {
      ...initialFormState
    },
    key2FieldConfig: {
      rows: {
        label: 'Trends',
        required: false
      }
    }
  });


  return React.useMemo(
    () => {
      const { formState, genFieldProps, dispatch } = form;

      return {
        formState,
        genFieldProps,
        dispatch
      };
    },
    [form]
  );
}
